import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getPublicApiUrl } from '../config/api';

function useContactFormSubmit() {
  // Используем переменную окружения или fallback на config
  const API_BASE_URL = process.env.REACT_APP_CONTACT_FORM_URL || getPublicApiUrl('contact');

  const { t } = useTranslation();
  const [formData, setFormData] = useState({ email: '', message: '' });

  const [status, setStatus] = useState({
    loading: false,
    result: null

  });

  const updateFormData = (name, value) => {
    setFormData(prev => ({ ...prev, [name]: value }));
  };


  const handleSubmit = async (formDataToSend) => {
    setStatus({ loading: true, error: null, success: false });




    try {
      const response = await fetch(`${API_BASE_URL}`, {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formDataToSend)
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || "Server response was not ok");
      }

      setStatus({
        loading: false,
        result: { type: 'success', messageKey: 'messages.success.messageSent' }
      });
      setFormData({ email: '', message: '' });

      // Google Ads Conversion Tracking
      if (typeof window.gtag !== 'undefined') {
        window.gtag('event', 'conversion', {
          'send_to': 'AW-XXXXXXXXX/XXXXXXXXX', // Замените на ваш ID конверсии
          'value': 1.0,
          'currency': 'EUR'
        });
      }

      // Автоматически скрыть сообщение через 5 секунд
      setTimeout(() => {
        setStatus({ loading: false, result: null });
      }, 5000);

    } catch (err) {
      const errorDetails = err.message;
      setStatus({
        loading: false,
        result: { type: 'error', messageKey: 'messages.error.fallback', details: err.message }
      });
    }
  };

  return { status, formData, handleSubmit, updateFormData };
}

export default useContactFormSubmit;